import React from "react";
import { Controller, useFieldArray, useFormContext, useWatch } from "react-hook-form";
import { Button, Card, Checkbox, FormGroup, Input } from "@cofano/cck";
import { Box, Grid2 as Grid } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { Language, usePermission } from "utils";
import { FormErrorMessage } from "components/form/FormErrorMessage";
import { LocationSchemaInput, LocationSchemaOutput } from "view/locations/utils/location.schema";

const LocationContactsForm = () => {

	const { control } = useFormContext<LocationSchemaInput, unknown, LocationSchemaOutput>();
	const { isSkipperOrShipManager } = usePermission();

	const { fields, append, remove } = useFieldArray({
		control: control,
		name: "contacts",
	});

	const contacts = useWatch({
		control: control,
		name: "contacts",
	});

	return (
		<Box p={2} pt={fields.length === 0 ? 2 : 0}>
			{fields.map((field, index) => {
				return (
					<Card
						key={field.id}
						title={Language("CONTACT")}
						subtitle={contacts[index]?.name}
						actions={[ {
							onClick: () => remove(index),
							icon: <DeleteIcon />,
						} ]}
						collapsable>
						<Grid spacing={3} container>
							<Grid size={12}>
								<FormGroup label={Language("FIRST_NAME")} labelPlacement="left-center" overflow="hidden">
									<Controller
										name={`contacts.${index}.name`}
										control={control}
										render={({ field, formState }) => (
											<React.Fragment>
												<Input {...field} />
												<FormErrorMessage name={field.name} errors={formState.errors} />
											</React.Fragment>
										)} />
								</FormGroup>

								<FormGroup label={Language("INSERTION")} labelPlacement="left-center" overflow="hidden">
									<Controller
										name={`contacts.${index}.insertion`}
										control={control}
										render={({ field, formState }) => (
											<React.Fragment>
												<Input {...field} />
												<FormErrorMessage name={field.name} errors={formState.errors} />
											</React.Fragment>
										)} />
								</FormGroup>

								<FormGroup label={Language("SURNAME")} labelPlacement="left-center" overflow="hidden">
									<Controller
										name={`contacts.${index}.surName`}
										control={control}
										render={({ field, formState }) => (
											<React.Fragment>
												<Input {...field} />
												<FormErrorMessage name={field.name} errors={formState.errors} />
											</React.Fragment>
										)} />
								</FormGroup>

								<FormGroup label={Language("EMAIL")} labelPlacement="left-center" overflow="hidden">
									<Controller
										name={`contacts.${index}.email`}
										control={control}
										render={({ field, formState }) => (
											<React.Fragment>
												<Input {...field} />
												<FormErrorMessage name={field.name} errors={formState.errors} />
											</React.Fragment>
										)} />
								</FormGroup>

								<FormGroup label={Language("TELEPHONE")} labelPlacement="left-center" overflow="hidden">
									<Controller
										name={`contacts.${index}.telephone`}
										control={control}
										render={({ field, formState }) => (
											<React.Fragment>
												<Input {...field} />
												<FormErrorMessage name={field.name} errors={formState.errors} />
											</React.Fragment>
										)} />
								</FormGroup>

								<FormGroup label={Language("FAX")} labelPlacement="left-center" overflow="hidden">
									<Controller
										name={`contacts.${index}.fax`}
										control={control}
										render={({ field, formState }) => (
											<React.Fragment>
												<Input {...field} />
												<FormErrorMessage name={field.name} errors={formState.errors} />
											</React.Fragment>
										)} />
								</FormGroup>

								{!isSkipperOrShipManager && (
									<FormGroup label={Language("VISIBLE_FOR_SHIP")} labelPlacement="left-center" overflow="hidden">
										<Controller
											name={`contacts.${index}.visibleForShip`}
											control={control}
											render={({ field, formState }) => (
												<React.Fragment>
													<Checkbox  {...field} checked={field.value} value={undefined} />
													<FormErrorMessage name={field.name} errors={formState.errors} />
												</React.Fragment>
											)} />
									</FormGroup>
								)}
							</Grid>
						</Grid>
					</Card>
				);
			})}

			<Box>
				<Button
					icon={<AddIcon />}
					onClick={() => {
						append({
							id: null,
							name: "",
							insertion: "",
							surName: "",
							email: "",
							telephone: "",
							fax: "",
							visibleForShip: false,
						});
					}}
					size="small"
					variant="outlined" />
			</Box>
		</Box>
	);
};

export default LocationContactsForm;
